/* maintainObjectTracking.component.js */

const maintainObjectTracking = {
    template: `<div>
        <page-header></page-header>
        <maintain-object-tracking-grid></maintain-object-tracking-grid>
        </div>`
};

export default maintainObjectTracking;